import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-calyrafit-banner.js';

const html = `
<div class="wrap-banner">
  <div class="wrap-media" data-attribute="wrap-media" data-use-vid="true">
    <div class="wrap-image-banner" data-attribute="wrap-image-banner" style="display: none;">
      <img data-attribute="image-banner" src="" alt="" />
    </div>
    <div class="wrap-video-banner" data-attribute="wrap-video-banner">
      <video
        data-attribute="video-banner"
        src="https://cdn-cf-east.streamable.com/video/mp4/idtnaj.mp4?Expires=1787198121145&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ&Signature=gHNXjxsswuuraoxRdY-9L94rCSVOgKXdszda0O2Q-jSjOe8DtmlZfrBTiOLIAQayPVzY6J~IHse4Ts9PyDIQHI0~L-4uDZmdMEOIvYe4oca3Dsm71fd07Fnl5K9sLR2gvq9tMOMdiKRTnL7BVMRBMX4Zdrk6Ofp7F-Q-agXgirFclKaGrWxdn4mYriqTblpeuAKxO35yqjtykfmB0-yc8sQbDYJcypKh9K3V4CA63LxDunGfAOBTUDO4GocnbZ4ds7fwFb4aToXCqmOO9-WO5XQJdueDwilD~1i9r4KCQbPmWVcdYEB03URiMfM7e0UPj-wnMUY9KDHLkOUxxk7hJg__"
        autoplay
        playsinline
        muted
        loop
      ></video>
    </div>
  </div>
  <div class="group-highlight">
    <div
      col-per-view="4"
      data-show="true"
      class="wrap-highlights container"
      data-attribute="wrap-highlights"
      style="--col-per-view: 4;"
    >
      <div data-attribute="item-highlight" class="item-highlight">
        <h3>200k+</h3>
        <p>5 Star Reviews</p>
      </div>
      <div data-attribute="item-highlight" class="item-highlight">
        <h3>1 Million+</h3>
        <p>Trusted Customers</p>
      </div>
      <div data-attribute="item-highlight" class="item-highlight">
        <h3>180-Day</h3>
        <p>Guaranteee</p>
      </div>
      <div data-attribute="item-highlight" class="item-highlight">
        <h3>30-Day</h3>
        <p>money back</p>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  topPadding: false,
  bottomPadding: false,
});
